<template>
  <div>
    <!-- Tabla con denuncias -->
    <v-col v-if="dView == 0">
      <datEmbededViewComplaintsTable v-bind="cProp" 
                                    @snackbar-msg="mxfSendParent('snackbar-msg', $event)" 
                                    @go-to-detail-view="fGoToDetail" 
                                    @reload-kpis="mxfSendParent('reload-kpis')"  /> 
    </v-col>
    <!-- Detalle denuncia -->
    <v-col v-else-if="dView == 1">
      <datEmbededViewComplaintDetail v-bind="cProp" 
                                    @snackbar-msg="mxfSendParent('snackbar-msg', $event)" 
                                    @go-back="fGoToTable" 
                                    @reload-kpis="mxfSendParent('reload-kpis')"  
                                    :pComplaintInfo="dComplaintInfo" 
                                    :pEditable="dEditable"/> 
    </v-col>
    <!-- Recuperación denuncia anónima -->
    <v-col v-else-if="dView == 2">
      <datEmbededViewAnonymComplaint v-bind="cProp" @snackbar-msg="mxfSendParent('snackbar-msg', $event)" @go-to-detail-view="fGoToDetail"  />
    </v-col>
  </div>
</template>

<script>
import datEmbededViewComplaintDetail from '@/views/embeded/datEmbededViewComplaintDetail.vue'
import datEmbededViewComplaintsTable from '@/views/embeded/datEmbededViewComplaintsTable.vue'
import datEmbededViewAnonymComplaint from '@/views/embeded/datEmbededViewAnonymComplaint.vue'

export default {
  components: { 
    datEmbededViewComplaintDetail,
    datEmbededViewComplaintsTable,
    datEmbededViewAnonymComplaint 
  },
  props:{
    newComplaint:{
      type: String,
      default: 'false'
    }
  },
  created(){
    //Almacena en el localStorage el token de la sesión o el oid. 
    // Si tiene oid, la denuncia proviene de una web externa, si tiene token, es interna 
    if(this.$route.query.token != null){
      localStorage.setItem("token", this.$route.query.token)
      this.dView = 0
    }
    else if(this.$route.query.oid != null){
      localStorage.setItem("oid", this.$route.query.oid)
      localStorage.setItem("externOrigin", true)
      this.dView = this.$route.query.newComplaint == 'true' ?  1 : 2
    }    
  },
  computed: {
    cProp(){
      return this.$route.query
    }
  },
data () {
    return {
      dEditable: true,
      dComplaintInfo: null ,
      dView: null,
      dExternalOrigin: localStorage.getItem("externOrigin")
    }
  },

  methods:{
    fGoToDetail(complaintInfo){
      this.dEditable = complaintInfo ? false : true 
      this.dComplaintInfo = complaintInfo
      this.dView = 1 
    },

    fGoToTable(){
      if(this.dExternalOrigin){
        this.dView = 2
      }else{
        this.dView = 0
      }
    }
  }
}
</script>